import { useEffect, type RefObject } from "react";

/**
 * Calls `onOutside` on any click/mousedown outside `ref`'s element — only
 * while `active`. Used to close an open popover/dropdown (the top bar's
 * project/editor menus, language selector...) without a full click-outside
 * library. `mousedown` (not `click`) so it fires before whatever the click
 * would otherwise trigger underneath (e.g. a sub-basin on the map).
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  onOutside: () => void,
  active: boolean
) {
  useEffect(() => {
    if (!active) return;
    function handlePointerDown(e: MouseEvent) {
      if (ref.current && e.target instanceof Node && !ref.current.contains(e.target)) {
        onOutside();
      }
    }
    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [ref, onOutside, active]);
}
